import logo from './logo.svg';
import './App.scss';
import {Routes, Route, Navigate} from 'react-router-dom';
import {Layout} from './components/Layout';
import {Home} from './components/Home';
import {About} from './components/Home/About';
import {Contact} from './components/Home/Contact';

function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Layout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="about" element={<About/>}/>
                    <Route path="contact" element={<Contact/>}/>
                </Route>
                <Route path={'/*'} element={<Navigate to={'/'}/>}/>
            </Routes>
        </>
    );
}

export default App;
